export const buildMapEmbedUrl = (addressQuery) => {
  const q = encodeURIComponent(addressQuery);
  return `https://www.google.com/maps?q=${q}&hl=tr&z=15&output=embed`;
};

export const buildMapsDirectionsUrl = (addressQuery) => {
  const q = encodeURIComponent(addressQuery);
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
};
